import { ConfigService } from './services/config.service';

/**
 * Factory function for APP_INITIALIZER
 * This ensures configuration is loaded before the app starts
 */
export function initializeApp(configService: ConfigService) {
  return (): Promise<any> => {
    return configService.loadConfig().toPromise();
  };
}
